import { isMobile } from '@/utils';
import { getCookie, getUrlParameter } from './base';

export const CONFIG_WEB = {
	apiKey: 'ixiweb!2$',
	clientId: 'ixiweb',
};

export const CONFIG_MOBILE = {
	apiKey: 'iximweb!2$',
	clientId: 'iximweb',
};

export const WEB_CLIENTS = [CONFIG_WEB.clientId, CONFIG_MOBILE.clientId];

export const getClientId = () => {
	const clientId = getCookie('clientId');
	const config = isMobile() ? CONFIG_MOBILE : CONFIG_WEB;
	const urlParamClientId = getUrlParameter('clientId');
	return clientId || urlParamClientId || config.clientId;
};

export function isConfirmTicket(): boolean {
	return 'confirmtckt' === getClientId();
}

export function isAbhiBus(): boolean {
	const clientId = getClientId();
	return (
		'abhibus' === clientId || 'abusad' === clientId || 'abusio' === clientId
	);
}

export function isMeesho(): boolean {
	return 'meesho' === getClientId();
}

export function isPhonepe(): boolean {
	return 'phonepe' === getClientId();
}
export const EXTERNAL_CLIENTS = {
	meesho: isMeesho,
	phonepe: isPhonepe,
};
export const THIRD_PARTY_CLIENTS = {
	confirmtckt: isConfirmTicket,
	abhibus: isAbhiBus,
	...EXTERNAL_CLIENTS,
};
export function isThirdPartyClient() {
	return Object.values(THIRD_PARTY_CLIENTS).some((check) => check());
}

export function isForeignEnvironment(clientId?: string) {
	const _clientId = clientId || getClientId();
	return _clientId && !WEB_CLIENTS.includes(_clientId as string);
}
